<div class="form-group new-tabs d-flex" [ngClass]="{'tabs-float' : combinedWithDropdownButtons}" *ngIf="availableTabs.length > 1">
    <div class="tab text-center" *ngFor="let tab of availableTabs" (click)="openTab(tab)" [ngClass]="{'active':tab.active}" [attr.title]="tab.label">
        {{tab.label}}
    </div>
</div>

